import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosuratcab() {



    const cardData = {




keyword: "Mumbai to Surat Cab",

headingDescription: "Shreesha Tours & Travels offers reliable, comfortable, and affordable Mumbai to Surat cab services for business travelers, families, tourists, corporate clients, and outstation passengers. We provide one-way cabs, round-trip taxi services, airport transfers, and customized travel solutions with professional chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars suitable for individuals, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure timings, transparent pricing, easy booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and comfortable journey from Mumbai to Surat. Whether you are traveling for business meetings, diamond market visits, textile shopping, family functions, religious trips, or weekend holidays, our Mumbai to Surat cab service provides clean vehicles, experienced drivers, and punctual service. Enjoy a convenient road trip through the Mumbai–Ahmedabad Highway with complete travel comfort and personalized service.",

topPlaces: [
  {
    title: "Dumas Beach",
    description: "Dumas Beach is one of Surat's most popular coastal attractions, known for its long shoreline, peaceful sea views, local food stalls, and evening atmosphere. It is a favorite destination for families, couples, and visitors looking to enjoy a relaxing time near the Arabian Sea."
  },
  {
    title: "Surat Castle",
    description: "Surat Castle is a historic fort built during the 16th century to protect the city from invasions. Located near the Tapi River, the restored monument showcases Surat's rich history, ancient architecture, and cultural heritage."
  },
  {
    title: "Dutch Garden",
    description: "Dutch Garden is a beautifully maintained historical garden featuring European-style architecture, peaceful walking paths, and old colonial tombs. It is a popular sightseeing place for visitors interested in history and photography."
  },
  {
    title: "Sarthana Nature Park",
    description: "Sarthana Nature Park is a family-friendly destination featuring a zoo, botanical garden, and various animal species. It is one of Surat's most visited attractions, especially popular among children and families."
  },
  {
    title: "ISKCON Temple Surat",
    description: "ISKCON Temple Surat is a peaceful spiritual destination known for its beautiful architecture, devotional atmosphere, and cultural activities. Devotees and visitors visit the temple to experience meditation, prayers, and spiritual peace."
  },
  {
    title: "Gopi Talav",
    description: "Gopi Talav is a historic lake and recreational destination in Surat, beautifully developed with gardens, fountains, boating facilities, and entertainment areas. It is an ideal place for families and tourists to spend relaxing time."
  },
  {
    title: "Tapi Riverfront",
    description: "Tapi Riverfront is a scenic attraction offering beautiful views of the Tapi River, walking areas, gardens, and peaceful surroundings. It is a popular evening destination for locals and tourists visiting Surat."
  },
  {
    title: "VR Surat",
    description: "VR Surat is one of the city's largest shopping and entertainment destinations, featuring premium brands, restaurants, multiplex cinemas, and family entertainment options. It is a perfect place for shopping and leisure activities."
  },
  {
    title: "Hazira Beach",
    description: "Hazira Beach is a peaceful coastal destination near Surat known for its natural beauty, calm environment, and scenic sunset views. It is a great place for travelers seeking a quiet escape away from city crowds."
  },
  {
    title: "Bardoli",
    description: "Bardoli is a historic town near Surat known for its connection with India's freedom movement and Sardar Vallabhbhai Patel's leadership. Visitors explore its historical landmarks and peaceful surroundings while traveling around the Surat region."
  }
],



"services": [
  {
    "name": "Mumbai to Surat Cab",
    "description": "Book Mumbai to Surat Cab for a safe, comfortable, and reliable outstation journey with professional chauffeurs, clean AC vehicles, and affordable travel packages. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Kia Carens cab options for business trips, family travel, airport transfers, corporate transportation, and personal journeys. Enjoy doorstep pickup, flexible one way and round trip booking facilities, transparent fares, and smooth highway travel from Mumbai to Surat with 24x7 cab availability."
  },
  {
    "name": "Mumbai to Surat Taxi",
    "description": "Hire Mumbai to Surat Taxi service for a convenient and hassle-free travel experience with experienced drivers, well-maintained cars, and comfortable seating. Our chauffeur-driven taxis are suitable for family tours, business meetings, corporate travel, medical visits, and long-distance transportation needs with reliable pickup and drop facilities."
  },
  {
    "name": "Mumbai to Surat Cab Service",
    "description": "Choose Mumbai to Surat Cab Service for dependable outstation transportation with professional drivers, premium vehicles, and customer-friendly booking options. Travel comfortably between Mumbai and Surat with Sedan, Ertiga, Innova Crysta, and SUV cabs designed for individuals, families, and corporate passengers. Get flexible travel schedules, affordable packages, and safe highway journeys."
  },
  {
    "name": "Mumbai to Surat Taxi Service",
    "description": "Book Mumbai to Surat Taxi Service for reliable intercity travel with trained chauffeurs, clean AC vehicles, and transparent pricing. Enjoy comfortable transportation for personal trips, corporate requirements, family vacations, airport transfers, and long-distance journeys with multiple cab categories available."
  },
  {
    "name": "Mumbai to Surat Cab Booking",
    "description": "Complete Mumbai to Surat Cab Booking online with quick confirmation, easy reservations, and multiple vehicle choices. Select your preferred cab based on passenger count, luggage capacity, and travel requirements. Enjoy doorstep pickup, professional drivers, comfortable rides, and convenient one way or round trip travel options."
  },
  {
    "name": "Mumbai to Surat Car Rental",
    "description": "Choose Mumbai to Surat Car Rental for private chauffeur-driven vehicles with flexible travel plans and premium comfort. Get well-maintained cars for family trips, business travel, corporate journeys, sightseeing, and personal transportation with experienced drivers and affordable rental packages."
  },
  {
    "name": "Mumbai to Surat Taxi Fare",
    "description": "Check Mumbai to Surat Taxi Fare with transparent pricing and affordable travel packages. Get competitive rates with no hidden charges, comfortable AC vehicles, and professional chauffeurs. Choose from multiple vehicle options according to your budget, group size, and travel needs."
  },
  {
    "name": "Mumbai to Surat Cab Fare",
    "description": "Get Mumbai to Surat Cab Fare with budget-friendly packages and reliable cab services. Enjoy comfortable long-distance travel with experienced drivers, clean vehicles, and flexible pricing options for one way, round trip, airport transfers, and corporate transportation."
  },
  {
    "name": "Mumbai to Surat One Way Cab",
    "description": "Book Mumbai to Surat One Way Cab for economical single-direction travel without return charges. Enjoy fixed pricing, comfortable seating, professional chauffeur service, and clean AC vehicles for a smooth and convenient journey from Mumbai to Surat."
  },
  {
    "name": "Mumbai to Surat Round Trip Taxi",
    "description": "Reserve Mumbai to Surat Round Trip Taxi for convenient return travel with flexible schedules and affordable packages. Perfect for business visits, family functions, personal trips, and extended stays with comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Surat Outstation Cab",
    "description": "Hire Mumbai to Surat Outstation Cab for safe and comfortable long-distance transportation with experienced chauffeurs and premium vehicles. Enjoy reliable travel solutions with Sedan, Ertiga, Innova Crysta, SUV, and luxury cab options for personal and corporate journeys."
  },
  {
    "name": "Mumbai Airport to Surat Cab",
    "description": "Book Mumbai Airport to Surat Cab for timely airport pickup and drop services with professional drivers and comfortable vehicles. Enjoy stress-free airport transfers from Mumbai Airport to Surat with reliable cab availability, clean interiors, and flexible booking options."
  },
  {
    "name": "Mumbai to Surat Car Hire",
    "description": "Choose Mumbai to Surat Car Hire services for private transportation with experienced chauffeurs and comfortable vehicles. Ideal for business travel, family tours, corporate requirements, and long-distance journeys with customizable travel packages."
  },
  {
    "name": "Navi Mumbai to Surat Cab",
    "description": "Book Navi Mumbai to Surat Cab for convenient outstation travel with professional drivers and well-maintained AC cars. Enjoy comfortable pickup services from Navi Mumbai locations with flexible one way and round trip options for personal and business travel."
  },
  {
    "name": "Thane to Surat Taxi",
    "description": "Choose Thane to Surat Taxi for affordable and reliable transportation with skilled chauffeurs and premium vehicles. Travel comfortably from Thane to Surat for family trips, corporate travel, airport transfers, and private journeys."
  },
  {
    "name": "Mumbai to Surat Innova Cab",
    "description": "Book Mumbai to Surat Innova Cab for spacious and comfortable travel with premium seating, large luggage capacity, and experienced chauffeurs. Perfect for families, groups, business travelers, and passengers looking for a relaxed long-distance journey."
  },
  {
    "name": "Mumbai to Surat Innova Crysta Cab",
    "description": "Choose Mumbai to Surat Innova Crysta Cab for luxury outstation travel with advanced comfort features, spacious interiors, and professional chauffeur service. Ideal for executives, families, corporate groups, and passengers who prefer premium travel experiences."
  },
  {
    "name": "Mumbai to Surat Ertiga Cab",
    "description": "Reserve Mumbai to Surat Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors and spacious seating. Suitable for family trips, group journeys, airport transfers, and long-distance travel requirements."
  },
  {
    "name": "Mumbai to Surat Sedan Cab",
    "description": "Book Mumbai to Surat Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Ideal for couples, small families, business trips, and smooth highway journeys with affordable travel packages."
  },
  {
    "name": "Mumbai to Surat SUV Cab",
    "description": "Hire Mumbai to Surat SUV Cab for spacious seating, premium comfort, and additional luggage capacity. Perfect for families, groups, corporate travelers, and passengers looking for a comfortable and reliable outstation journey."
  },
  {
    "name": "Mumbai to Surat Kia Carens Cab",
    "description": "Book Mumbai to Surat Kia Carens Cab for premium family travel with spacious interiors, comfortable seating, and modern features. Suitable for group tours, corporate travel, and passengers who want a luxurious and convenient journey experience."
  },
  {
    "name": "Reliable Mumbai Surat Taxi Service",
    "description": "Choose Reliable Mumbai Surat Taxi Service for safe, punctual, and comfortable transportation with professional chauffeurs and well-maintained vehicles. Enjoy dependable one way and round trip cab solutions with transparent pricing, flexible booking options, and excellent customer support."
  }
],
"tableData": [
  ["Mumbai to Surat Cab", "Mumbai to Surat Taxi"],
  ["Mumbai to Surat Cab Service", "Mumbai to Surat Taxi Service"],
  ["Mumbai to Surat Cab Booking", "Mumbai to Surat Car Rental"],
  ["Mumbai to Surat Taxi Fare", "Mumbai to Surat Cab Fare"],
  ["Mumbai to Surat One Way Cab", "Mumbai to Surat Round Trip Taxi"],
  ["Mumbai to Surat Outstation Cab", "Mumbai Airport to Surat Cab"],
  ["Mumbai to Surat Car Hire", "Navi Mumbai to Surat Cab"],
  ["Thane to Surat Taxi", "Mumbai to Surat Innova Cab"],
  ["Mumbai to Surat Innova Crysta Cab", "Mumbai to Surat Ertiga Cab"],
  ["Mumbai to Surat Sedan Cab", "Mumbai to Surat SUV Cab"],
  ["Mumbai to Surat Kia Carens Cab", "Reliable Mumbai Surat Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Surat Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers a convenient Mumbai to Surat cab service for business travellers, families, and personal journeys with comfortable vehicles and professional drivers."
  },
  {
    WhyChooseheading: "Direct Travel Between Mumbai & Surat",
    WhyChoosedescription: "Enjoy a hassle-free road journey with doorstep pickup and direct drop facilities, allowing you to travel comfortably without depending on fixed schedules."
  },
  {
    WhyChooseheading: "Cab Options for Every Type of Traveller",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller according to your passenger count and comfort preference."
  },
  {
    WhyChooseheading: "Suitable for Corporate & Personal Trips",
    WhyChoosedescription: "Whether travelling for meetings, business visits, family functions, shopping, or personal work, our Mumbai to Surat taxis provide a practical travel solution."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Highway Routes",
    WhyChoosedescription: "Our trained drivers have experience with long-distance highway travel and focus on safety, punctuality, and a smooth driving experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Journey Plans",
    WhyChoosedescription: "Select a one-way cab, round-trip taxi, or customized travel plan based on your schedule and destination requirements."
  },
  {
    WhyChooseheading: "Comfortable Cars for Long Distance Travel",
    WhyChoosedescription: "Travel in air-conditioned vehicles with clean interiors, comfortable seating, and sufficient luggage space for a relaxed Mumbai to Surat journey."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Get quick cab availability, transparent pricing, and travel support while arranging your Mumbai to Surat taxi booking."
  }
]

};

const faqData = [
  {
    question: "Why choose a Mumbai to Surat cab instead of other travel options?",
    answer: "A private cab provides door-to-door convenience, flexible stops, privacy, and a comfortable travel experience for long-distance journeys."
  },
  {
    question: "Can I book Mumbai to Surat one-way cab service?",
    answer: "Yes, one-way taxi options are available for travellers who require direct transportation from Mumbai to Surat."
  },
  {
    question: "What types of vehicles are available for Mumbai to Surat travel?",
    answer: "You can select Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller based on your requirement."
  },
  {
    question: "Is Mumbai to Surat taxi suitable for business travel?",
    answer: "Yes, our comfortable cabs are suitable for corporate meetings, industrial visits, business tours, and professional travel."
  },
  {
    question: "Can I book a return cab from Surat to Mumbai?",
    answer: "Yes, round-trip taxi services are available with flexible return timing according to your travel plan."
  },
  {
    question: "Do you provide Mumbai pickup from airport and railway station?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
  },
  {
    question: "Is overnight travel available from Mumbai to Surat?",
    answer: "Yes, overnight cab travel can be arranged according to vehicle availability and customer requirements."
  },
  {
    question: "Are toll and parking charges included in the Mumbai to Surat cab fare?",
    answer: "Applicable tolls, parking fees, permits, and additional charges depend on the selected package and are explained before booking."
  },
  {
    question: "Can I book a Mumbai to Surat cab for family functions?",
    answer: "Yes, our vehicles are suitable for attending weddings, family events, social functions, and group travel."
  },
  {
    question: "How can I reserve a Mumbai to Surat Cab with Shreesha Tours & Travels?",
    answer: "Provide your pickup location, travel date, passenger details, and preferred vehicle type to get cab availability and booking details."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Shah",
    feedback: "I travelled from Mumbai to Surat for business work. Shreesha Tours & Travels arranged a comfortable sedan with a professional driver, making the long journey convenient.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rupal Mehta",
    feedback: "Our family booked an Innova for Mumbai to Surat travel. The car was spacious, the driver was polite, and the overall service was smooth and reliable.",
    rating: 5
  }
];
























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Surat Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-surat-cab.webp",
  "description":
    "Book Mumbai to Surat Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Surat with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, corporate trips, family vacations, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-surat-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Mumbai to Surat Cab | Intercity Travel Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Surat Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Surat with 24x7 online cab booking and professional drivers."
  />

  <meta
    name="keywords"
    content="Mumbai to Surat Cab, Mumbai to Surat Taxi, Mumbai to Surat Cab Service, Mumbai to Surat Taxi Service, Mumbai to Surat One Way Cab, Mumbai to Surat Round Trip Cab, Mumbai to Surat Cab Booking, Mumbai to Surat Taxi Booking, Mumbai to Surat Car Rental, Mumbai to Surat Outstation Cab, Mumbai to Surat Innova Cab, Mumbai to Surat Sedan Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitosuratcab;